module.exports = __webpack_public_path__ + "img/95.c58aeb58.jpg";